const paraImg = document.querySelector('#paralleximg');
    const paraContent = document.querySelector('#parallexcontent');
    const paraWrap = document.querySelector('#parallexWrapper');
      document.addEventListener('scroll', function (e) {
        if (paraImg && paraImg != null) {

        if (paraImg.getBoundingClientRect().top < 0 ) {
            paraImg.classList.add('parallex-fixed');
          // console.log('paraimg',paraImg.getBoundingClientRect().top);
        }else{
            //paraImg.classList.remove('parallex-fixed');
        }
        if (paraContent.getBoundingClientRect().top < 0 ) {
            paraImg.classList.remove('parallex-fixed');
        }
        if (paraWrap.getBoundingClientRect().top > 0 ) {
           paraImg.classList.remove('parallex-fixed');
        }
      }
      });